import Sources from './mixins/sources';

export default function (sources) {
  Sources.setSources(sources);
};
